export default {"src":"/_next/static/media/arrowLeft.b8ae5f01.svg","height":24,"width":23,"blurWidth":0,"blurHeight":0};